import {
	createStyles,
} from '@mui/styles';
import {
	Theme,
} from '@mui/material/styles';
// Import enumerations.
import { BreakpointWidth } from '@app/enumerations';

const styles = (theme: Theme) => {
	return createStyles({
		CATLogo_logoExteriorWrapper: {
			display: 'flex',
			flexDirection: 'column',
			justifyContent: 'center',
		},
		CATLogo_logoInteriorWrapper: {
			display: 'flex',
			flexDirection: 'row',
		},
		CATLogo_logo: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				height: '40px',
			},
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				height: '50px',
			},
			margin: '0px'
		},
		CATLogo_logoUp: {
			[theme.breakpoints.down(BreakpointWidth.LARGE)]: {
				display: 'none'
			},
		},
		CATLogo_logoDown: {
			[theme.breakpoints.up(BreakpointWidth.LARGE)]: {
				display: 'none'
			},
		},
		CATLogo_logoLink: {
			display: 'flex',
			flexDirection: 'row',
		}
	});
}

export default styles;
